module.exports = __webpack_public_path__ + "img/google-play-logo.d0fe0b59.svg";